import React, { useEffect, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import { BsTelephone } from "react-icons/bs";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";

const VendorAndCustomerDetails = ({ deliveryDetails, vendorDetails }) => {
  return (
    <>
      {deliveryDetails ? (
        <div>
          <h3 className="font-semibold mb-2 text-lg">Order by</h3>
          <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
            {deliveryDetails?.name ?? "N/A"}
          </p>
          <div className="flex justify-start gap-2 items-center mt-1">
            <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
            <p className="text-gray-500 text-xl hover:text-blue-900 transition duration-300">
              {deliveryDetails?.phone_number ?? "N/A"}
            </p>
          </div>

          <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
            <CiLocationOn className="text-3xl text-blue-900" />
            <p className="text-gray-700">
              {deliveryDetails?.flat_no ?? "N/A"}, {deliveryDetails?.landmark ?? "N/A"},
              {deliveryDetails?.street ?? "N/A"}, {deliveryDetails?.pin_code ?? "N/A"}
            </p>
          </div>
        </div>
      ) : (
        ""
      )}
      <hr />
      {vendorDetails ? (
        <div>
          <h3 className="font-semibold mt-4 mb-2 text-lg">Vendor Details</h3>
          <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
            {vendorDetails?.first_name ?? "N/A"}
          </p>
          <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
            <CiLocationOn className="text-3xl text-blue-900" />
            <p className="text-gray-700">{vendorDetails?.address ?? "N/A"}</p>
          </div>
        </div>
      ) : (
        ""
      )}
      <hr />
    </>
  );
};

const VendorEarnings = ({ vendorEarnings, ProductDeatils,earningData }) => {
  const [data, setData] = useState([]);
  const [productDetails, setProductDetails] = useState();

  const fallbackFormattedAmount = (amount) => `₵${Number(amount).toFixed(2)}`;
  const formatFn = formattedAmount || fallbackFormattedAmount;

  useEffect(() => {
    if (Array.isArray(ProductDeatils)) {
      setData(ProductDeatils);
    } else {
      const details = ProductDeatils?.product?.product_details || ProductDeatils?.product || {};
      setProductDetails(details);
    }
  }, [ProductDeatils]);

  return (
    <div>
      <h3 className="font-semibold mb-2 text-lg">Vendor Earnings</h3>

      {data.length > 0 ? (
        data.map((product, index) => (
          <div key={index} className="mt-3">
            <h3 style={{ fontWeight: "700" }}>{`${index+1}. Product Detail `}</h3>
            <p>
              <b>Product:</b> {product?.product?.name || ""}
            </p>
            <p>
              <b>Quantity:</b> {product?.quantity || ""}
            </p>
            <p>
              Product Base Price:{" "}
              {formatFn(
                parseFloat(product?.price?.$numberDecimal || productDetails?.sales_price || 0).toFixed(2)
              )}
            </p>
            {/* <p>
              Total Price:{" "}
              {formatFn(
                parseFloat(earningData?.total|| product?.product?.taxData?.grandTotal?.$numberDecimal || product?.price || 0).toFixed(2)
              )}
            </p> */}

            {/* Add the table for each product */}
            <table className="mt-4">
              <thead>
                <tr>
                  <th>Name</th>
                  <th className="text-right">Rate</th>
                  <th className="text-right">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={2}>Product Base Price</td>
                  <td className="text-right">
                    {formatFn(
                      product?.price?.$numberDecimal || productDetails?.sales_price
                    )}
                  </td>
                </tr>
                {product?.product?.taxData?.standardTax?.map((t, i) => (
                  <tr key={i}>
                    <td>{t.name}</td>
                    <td className="text-right">{t?.rate?.$numberDecimal || t?.rate}%</td>
                    <td className="text-right">
                      {formatFn(t?.taxAmount?.$numberDecimal || t?.taxAmount)}
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={2} className="font-bold">Rebase Amount</td>
                  <td className="text-right">
                    {formatFn(
                      product?.product?.taxData?.taxableAmount?.$numberDecimal || productDetails?.taxData?.rebase
                    )}
                  </td>
                </tr>
                <tr>
                  <td>{product?.product?.taxData?.vat?.[0]?.name}</td>
                  <td className="text-right">
                    {product?.product?.taxData?.vat?.[0]?.rate?.$numberDecimal || "0"}%
                  </td>
                  <td className="text-right">
                    {formatFn(product?.product?.taxData?.vat?.[0]?.taxAmount?.$numberDecimal)}
                  </td>
                </tr>
                <tr>
                  <td colSpan={2} className="font-bold">Total</td>
                  <td className="text-right">{formatFn(product?.net_total?.$numberDecimal)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        ))
      ) : (
        <div>
          <h3 style={{ fontWeight: "700" }}>Product Details</h3>
          <p>
            <b>Product:</b> {ProductDeatils?.product?.name || ""}
          </p>
          <p>
            <b>Quantity:</b> {ProductDeatils?.quantity || ""}
          </p>
          <p>
            Product Base Price:{" "}
            {formatFn(
              parseFloat(
                productDetails?.sales_price?.$numberDecimal || productDetails?.sales_price || 0
              ).toFixed(2)
            )}
          </p>
          <p>
            Total Price:{" "}
            {formatFn(
              parseFloat(ProductDeatils?.net_total?.$numberDecimal||ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price  || 0).toFixed(2)
            )}
          </p>

          {/* Single product table */}
          <table className="mt-4">
            <thead>
              <tr>
                <th>Name</th>
                <th className="text-right">Rate</th>
                <th className="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan={2}>Product Base Price</td>
                <td className="text-right">
                  {formatFn(
                    productDetails?.sales_price?.$numberDecimal || productDetails?.sales_price
                  )}
                </td>
              </tr>
              {productDetails?.taxData?.standardTax?.map((t, i) => (
                <tr key={i}>
                  <td>{t.name}</td>
                  <td className="text-right">{t?.rate?.$numberDecimal || t?.rate}%</td>
                  <td className="text-right">
                    {formatFn(t?.taxAmount?.$numberDecimal || t?.taxAmount)}
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={2} className="font-bold">Rebase Amount</td>
                <td className="text-right">
                  {formatFn(
                    productDetails?.taxData?.rebase?.$numberDecimal || productDetails?.taxData?.rebase
                  )}
                </td>
              </tr>
              <tr>
                <td>{productDetails?.taxData?.vat?.[0]?.name}</td>
                <td className="text-right">
                  {productDetails?.taxData?.vat?.[0]?.rate?.$numberDecimal || "0"}%
                </td>
                <td className="text-right">
                  {formatFn(vendorEarnings.taxAmount)}
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="font-bold">Total</td>
                <td className="text-right">{formatFn(vendorEarnings.total)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};



const AdminEarnings = ({ adminEarnings,earningData }) => (
  <div>
    <h3 className="font-semibold mb-2 text-lg">Admin Earnings</h3>
    <table>
      <thead>
        <tr>
          <th>Fee Type</th>
          <th className="text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={2} className="text-center font-bold">Earning From Vendor</td>
        </tr>
        <tr>
          <td>Closing Fee</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromVendor.closingFee||earningData.orderDetails[0].product.taxData.adminEarning.closingFee.$numberDecimal)}</td>
        </tr>
        <tr>
          <td>Additional Fee</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromVendor.additionalFee||earningData.orderDetails[0].product.taxData.adminEarning.additionalFee.$numberDecimal)}</td>
        </tr>
        <tr>
          <td>Referral Fee @ ({adminEarnings.fromVendor.referralFee.percentage||earningData.orderDetails[0].product.taxData.adminEarning.referralFee.percentage.$numberDecimal}%)</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromVendor.referralFee.amount||earningData.orderDetails[0].product.taxData.adminEarning.referralFee.amount.$numberDecimal)}</td>
        </tr>
        <tr>
          <td>VAT</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromVendor.vat||earningData.orderDetails[0].product.taxData.adminEarning.vat.$numberDecimal)}</td>
        </tr>
        <tr>
          <td>Total (From Vendor)</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromVendor.total||earningData.orderDetails[0].product.taxData.adminEarning.total.$numberDecimal)}</td>
        </tr>
        <tr>
          <td colSpan={2} className="text-center font-bold">Earning From Deliveryman</td>
        </tr>
        <tr>
          <td>Server Fee</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromDeliveryMan.shippingHandlingFeeFixedRate||earningData.orderDetails[0].delivery_fee.adminEarning.shippingHandlingFeeFixedRate)}</td>
        </tr>
        <tr>
          <td>Shipping Fee @ ({adminEarnings.fromDeliveryMan.shippingFeeRate.percentage||earningData.orderDetails[0].delivery_fee.adminEarning.shippingFeeRate.percentage}%)</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromDeliveryMan.shippingFeeRate.amount||earningData.orderDetails[0].delivery_fee.adminEarning.shippingFeeRate.amount)}</td>
        </tr>
        <tr>
          <td>VAT</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromDeliveryMan.vat||earningData.orderDetails[0].delivery_fee.adminEarning.vat)}</td>
        </tr>
        <tr>
          <td>Total (From Deliveryman)</td>
          <td className="text-right">{formattedAmount(adminEarnings.fromDeliveryMan.total||earningData.orderDetails[0].delivery_fee.adminEarning.total)}</td>
        </tr>
        <tr>
          <td>Total Earnings</td>
          <td className="text-right">{formattedAmount(adminEarnings.total||earningData.adminEarn)}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

const DeliverymanEarnings = ({ deliverymanEarnings,ProductDeatils }) => (


  <div>
  <h3 className="font-semibold mb-2 text-lg">Deliveryman Earnings</h3>
  <table>
    <thead>
      <tr>
        <th>Factor Name</th>
        <th className="text-right">Value</th>
        <th className="text-right">Amount</th>
      </tr>
    </thead>
    <tbody>
      {/* If earnings data exists */}
      {deliverymanEarnings?.factors?.length > 0 ? (
        <>
          {deliverymanEarnings.factors.map((factor, index) => (
            <React.Fragment key={factor._id}>
              <tr>
                <td>{factor.name}</td>
                <td className="text-right">{factor.value}%</td>
                <td className="text-right">{formattedAmount(factor.amount)}</td>
              </tr>
              {/* Add Total row after the last factor */}
              {index === deliverymanEarnings.factors.length - 1 && (
                <tr>
                  <td colSpan={2} className="text-right font-semibold">Total</td>
                  <td className="text-right font-semibold">
                    {formattedAmount(deliverymanEarnings?.total || 0)}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </>
      ) : (
        <>
          {/* If ProductDetails is used */}
          {ProductDeatils.map((detail, index) => (
            <React.Fragment key={detail.delivery_fee.deliveryMan?._id}>
              <tr>
                {/* {JSON.stringify(detail.delivery_fee.deliveryMan.factor[0])} */}
                <td>{detail.delivery_fee.deliveryMan?.factor[0]?.name || 'N/A'}</td>
                <td className="text-right">{detail.delivery_fee.deliveryMan?.factor[0]?.value || 0}%</td>
                <td className="text-right">{formattedAmount(detail.delivery_fee.deliveryMan?.factor[0]?.amount || 0)}</td>
              </tr>
              {/* Add Total row after the last detail */}
              {index === ProductDeatils.length - 1 && (
                <tr>
                  <td colSpan={2} className="text-right font-semibold">Total</td>
                  <td className="text-right font-semibold">
                    {formattedAmount(detail.delivery_fee.deliveryMan?.total || 0)}
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </>
      )}
    </tbody>
  </table>
</div>


);

const EarningDetails = ({ ProductDeatils, deliveryDetails, vendorDetails,earningData }) => {
  console.log("earningData Earning:",earningData);
  
  const productDetails = ProductDeatils?.product?.product_details || ProductDeatils?.product || {};

  const earningsData = {
    rebaseAmount: productDetails.taxData?.rebase,
    tax: {
      name: productDetails.taxData?.vat?.[0]?.name,
      rate: productDetails.taxData?.vat?.[0]?.rate,
    },
    vendorEarnings: {
      taxAmount: productDetails.taxData?.vendorEarning?.vat,
      total: productDetails.taxData?.vendorEarning?.total?.$numberDecimal,
    },
    adminEarnsFromVendor: {
      adminEarnFromVendor: productDetails.taxData?.adminEarning,
      adminEarnFromDeliveryMan: ProductDeatils?.delivery_fee?.adminEarning,
    },
    deliveryManEarnings: ProductDeatils?.delivery_fee?.deliveryMan,
    adminTotalEarnings:
      parseFloat(productDetails.taxData?.adminEarning?.total?.$numberDecimal || 0) +
      parseFloat(ProductDeatils?.delivery_fee?.adminEarning?.total || 0),
  };

  const vendorEarnings = {
    taxAmount: parseFloat(earningsData.vendorEarnings.taxAmount?.$numberDecimal || 0),
    total: parseFloat(earningsData.vendorEarnings.total || 0),
  };

  const adminEarnings = {
    fromVendor: {
      closingFee: parseFloat(earningsData.adminEarnsFromVendor.adminEarnFromVendor?.closingFee?.$numberDecimal || 0),
      additionalFee: parseFloat(earningsData.adminEarnsFromVendor.adminEarnFromVendor?.additionalFee?.$numberDecimal || 0),
      referralFee: {
        percentage: parseFloat(earningsData.adminEarnsFromVendor.adminEarnFromVendor?.referralFee?.percentage?.$numberDecimal || 0),
        amount: parseFloat(earningsData.adminEarnsFromVendor.adminEarnFromVendor?.referralFee?.amount?.$numberDecimal || 0),
      },
      vat: parseFloat(earningsData.adminEarnsFromVendor.adminEarnFromVendor?.vat?.$numberDecimal || 0),
      total: parseFloat(earningsData.adminEarnsFromVendor.adminEarnFromVendor?.total?.$numberDecimal || 0),
    },
    fromDeliveryMan: {
      shippingHandlingFeeFixedRate: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan?.shippingHandlingFeeFixedRate || 0,
      shippingFeeRate: {
        percentage: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan?.shippingFeeRate?.percentage || 0,
        amount: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan?.shippingFeeRate?.amount || 0,
      },
      vat: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan?.vat || 0,
      total: earningsData.adminEarnsFromVendor.adminEarnFromDeliveryMan?.total || 0,
    },
    total: earningsData.adminTotalEarnings,
  };

  const deliverymanEarnings = {
    factors: earningsData.deliveryManEarnings?.factor?.map((factor) => ({
      name: factor.name,
      value: factor.value,
      amount: factor.amount,
      _id: factor._id,
    })) || [],
    total: earningsData.deliveryManEarnings?.total || 0,
  };

  return (
    <div id="invoice-POS" className="printable">
      <VendorAndCustomerDetails deliveryDetails={deliveryDetails} vendorDetails={vendorDetails} />
      <br />
      <VendorEarnings vendorEarnings={vendorEarnings} ProductDeatils={ProductDeatils} earningData={earningData} />
      <DeliverymanEarnings deliverymanEarnings={deliverymanEarnings} earningData={earningData} ProductDeatils={ProductDeatils}/>
      <AdminEarnings adminEarnings={adminEarnings} earningData={earningData}/>
      <div className="flex justify-between items-center border-t-2 ">
        <h3 className="font-bold">Net Total</h3>
        <p className="text-right font-bold">
          {formattedAmount(parseFloat(earningData?.total || ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price || 0).toFixed(2))}
        </p>
      </div>
    </div>
  );
};

export default EarningDetails;
